import FormattedMessage from 'I18n/components/FormattedMessage';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
export function MoveTicketButton({
  onClick,
  disabledReason = 'UNSUPPORTED',
  isDisabled = false,
  isLoading = false
}) {
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: !isDisabled,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `app.moveToSupportCard.tooltip.${disabledReason === 'DISABLED' ? 'disabled' : 'ineligible'}`
    }),
    children: /*#__PURE__*/_jsx(LoadingButton, {
      disabled: isDisabled || isLoading,
      failed: true,
      loading: isLoading,
      onClick: onClick,
      responsive: false,
      size: "xs",
      use: "tertiary-light",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: disabledReason === 'EMAIL_SUPPORTED_ONLY' ? 'app.moveToSupportCard.emailButton' : 'app.moveToSupportCard.button'
      })
    })
  });
}